<template>
  <div class="footer">
    <div class="f-content">
      <div class="left">
        <p>版权所有：青海省人大常委会</p>
        <p class="pc-show"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">备案号：青ICP备05000201号-2</a>
          <img src="@/assets/images/gh-icon.png" alt="">青公网安备 63010302000409号
        </p>
        <p class="h5-show"><a :href="isWexin ? 'javascript:void(0)' : 'https://beian.miit.gov.cn/#/Integrated/index'" target="_blank">备案号：青ICP备05000201号-2</a></p>
        <p class="h5-show"><img src="@/assets/images/gh-icon.png" alt="">青公网安备 63010302000409号</p>
      </div>
      <img class="pc-show" src="@/assets/images/footer-icon.png" />
      <img class="h5-show" src="@/assets/images/footer-icon-h5.png" />
    </div>
  </div>
</template>

<script>
import { isWexinFn } from '../utils/common.js';
export default {
  name: "FooterBox",
  data() {
    return {
      isWexin: false,
    };
  },
  mounted() {
    console.log(isWexinFn(), '---isWexin()');
    this.isWexin = isWexinFn() || false;
    console.log(this.isWexin, '---888');
    console.log(this.isWexin, '----isWexin');
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 100px;
  background-color: #eeeeeeb3;
  min-width: 1608px;
  .f-content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      margin: 0;
      font-size: 16px;
      line-height: 30px;
      color: #333333;

      img {
        width: 14px;
        height: 16px;
        margin: -3px 3px 0 10px;
      }
      a {
        color: inherit;
      }
    }

    &>img {
      width: 52px;
      height: 65px;
    }
  }
}

@media screen and (max-width: 768px) {
  .footer {
    width: 100%;
    height: 2.12rem;
    min-width: 100%;
    .f-content {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      padding: .45rem 1rem .45rem .63rem;
      box-sizing: border-box;
      p {
        margin: 0;
        font-size: .32rem;
        line-height: .48rem;
        img {
          width: .36rem;
          margin: -3px 3px 0 0px;
        }
      }
      &>img {
        width: .89rem;
        height: auto;
      }
    }
  }
}</style>